import { HttpClient } from "../../DriveScout/API/core/HttpClient";

const DS_USER_KEY = "ds-user";
const DS_TOKEN_KEY = "ds-token";

const state = {
  token: "",
  user: null,
  school: {},
  policies: {},
  usermeta: [],
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
    localStorage.setItem(DS_USER_KEY, JSON.stringify(user));
  },
  SET_USER_METADATA(state, metadata) {
    state.usermeta = metadata;
  },
  LOGOUT(state) {
    localStorage.removeItem(DS_TOKEN_KEY);
    localStorage.removeItem(DS_USER_KEY);
    state.user = null;
    state.token = "";
  },
  SET_TOKEN(state, token) {
    localStorage.setItem(DS_TOKEN_KEY, token);
    state.token = token;
    HttpClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  },
  REMOVE_TOKEN(state) {
    localStorage.removeItem(DS_TOKEN_KEY);
    delete state.token;
  },
  SET_SCHOOL(state, school) {
    state.school = school;
  },
  SET_POLICIES(state, policies) {
    state.policies = policies;
  },
};

const actions = {
  LOGOUT({ commit }) {
    commit("LOGOUT");
  },
  SET_TOKEN({ commit }, token) {
    if (token === null) {
      commit("REMOVE_TOKEN");
    } else {
      commit("SET_TOKEN", token);
    }
  },
  SET_USER({ commit }, user) {
    commit("SET_USER", user);
  },
  SET_SCHOOL({ commit }, school) {
    commit("SET_SCHOOL", school);
  },
  SET_POLICIES({ commit }, policies) {
    commit("SET_POLICIES", policies);
  },
  SET_USER_METADATA({ commit }, metadata) {
    commit("SET_USER_METADATA", metadata);
  },
};

const getters = {
  user: (state) => state.user,
  schoolId: (state) => state.school.id,
  policies: (state) => state.policies,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

